const aorRoot = '/api/aor/';

export const AorEndpoints = {
  // Determines if Project Location is within USACE jurisdiction
  getRegulatoryAorLayer: () => `${aorRoot}getRegulatoryAorLayer`,

  // Determines if AR is within the EEZ
  getRegulatoryAorEezLayer: () => `${aorRoot}getAreaNameFromGeometry`,

  // Gets District Name in Project Location
  getStateEezDistrictBoundaries: () => `${aorRoot}getDistrictFromGeometry`,
};
